import { gql } from '@apollo/client';
import { CARRIER_INVOICE_FIELDS } from '@/graphql/queries/carrier_invoices';
import { CLIENT_FIELDS } from '@/graphql/queries/clients';
import { CLAIM_ADJUSTMENT_FIELDS } from '@/graphql/fragments/claim_adjustments';
import { SUPPLEMENTAL_CHARGE_FIELDS } from '@/graphql/fragments/supplemental_charges';
import { INTEGRATION_OUTBOUND_FIELDS } from '@/graphql/fragments/integrations_outbound';

export const PAYABLE_ORDER_FIELDS = gql`
    ${INTEGRATION_OUTBOUND_FIELDS}

    fragment PayableOrderFields on orders {
        order_id
        order_number
        po_number
        reference_id
        pod
        delivery_photo
        customer_signature
        carrier_rate
        middle_mile_carrier_rate
        warehouse_carrier_rate
        contractor_rate
        price_breakdown
        qbo_tag
        invoice_class
        billing_completion_time

        outbound_integrations(
            where: { transaction_type: { _eq: "210_MOTOR_CARRIER_FREIGHT_DETAILS_AND_INVOICE" } }
            order_by: { status: desc }
            limit: 1
        ) {
            ...IntegrationOutboundFields
        }
    }
`;

export const PAYABLE_FIELDS = gql`
    ${CARRIER_INVOICE_FIELDS}
    ${CLAIM_ADJUSTMENT_FIELDS}
    ${SUPPLEMENTAL_CHARGE_FIELDS}
    ${PAYABLE_ORDER_FIELDS}
    ${INTEGRATION_OUTBOUND_FIELDS}

    fragment PayableFields on carrier_invoices {
        ...CarrierInvoiceFields
        netsuite_account_id
        netsuite_invoice_id

        outbound_integrations(
            where: { transaction_type: { _eq: "210_MOTOR_CARRIER_FREIGHT_DETAILS_AND_INVOICE" } }
            order_by: { status: desc }
            limit: 1
        ) {
            ...IntegrationOutboundFields
        }

        supplemental_charges {
            ...SupplementalChargeFields
        }

        claim_adjustments {
            ...ClaimAdjustmentFields
            claim {
                claim_id
                order {
                    ...PayableOrderFields
                }
            }
        }

        client {
            client_id
            business_name
        }

        orders {
            ...PayableOrderFields
        }

        middle_mile_carrier_orders {
            ...PayableOrderFields
        }

        warehouse_carrier_orders {
            ...PayableOrderFields
        }

        contractor_orders {
            ...PayableOrderFields
        }
    }
`;

export const PAYABLES = gql`
    ${PAYABLE_FIELDS}
    query GetPayables($where: carrier_invoices_bool_exp!, $limit: Int!, $offset: Int!) {
        results: carrier_invoices(where: $where, order_by: { created_at: desc }, limit: $limit, offset: $offset) {
            ...PayableFields
        }
    }
`;

export const GET_CARRIERS = gql`
    ${CLIENT_FIELDS}
    query GetCarriers($where: carrier_invoices_bool_exp!) {
        results: carrier_invoices(distinct_on: [client_id], where: $where) {
            carrier_invoice_id
            client_id
            client {
                ...ClientFields
            }
        }
    }
`;

export const UPDATE_INVOICES = gql`
    ${CARRIER_INVOICE_FIELDS}
    mutation UpdateInvoices($ids: [uuid!]!, $patch: carrier_invoices_set_input!) {
        updated: update_carrier_invoices(where: { carrier_invoice_id: { _in: $ids } }, _set: $patch) {
            returning {
                ...CarrierInvoiceFields
            }
        }
    }
`;
